module.exports = __webpack_public_path__ + "img/btn_delete.9b8dca92.svg";